angular.module('elidb').filter('dir', function() {
    return function(string) {
    	if(!string) return;
        return string.replace(/%DIR%/gim,__DIR__);
    	
    };
});